import { render } from "./JoinUsPage.vue?vue&type=template&id=c4f04ba6&scoped=true"
import script from "./_JoinUsPage.js?vue&type=script&lang=js"
export * from "./_JoinUsPage.js?vue&type=script&lang=js"

import "./_JoinUsPage.less?vue&type=style&index=0&id=c4f04ba6&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f04ba6"]])

export default __exports__